var classes = {"overlayMenuTabs":"uD-Eu"};

export { classes as default };
